import styled, { css } from "styled-components";

//MISC
import { CalendarType } from "./CalendarFilterModel";
import { COLORS, BORDER_RADIUS, DEVICE_TYPE, SIZE } from "constants/variables";

//ASSETS
import cursorIcon from "assets/img/Cursor.png";

export const SelectInputContainer = styled.div<{
  type?: keyof typeof CalendarType;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  padding: 0px 24px;
  width: 250px;
  border-radius: ${BORDER_RADIUS.radius21};
  background-color: ${COLORS.Background};
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    background-color: ${COLORS.Gunmetal};
  }
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    width: 100%;
  }
  ${({ type }) =>
    type === CalendarType.girdle &&
    css`
      background-color: ${COLORS.Gunmetal};
      width: ${SIZE.max320};
      border-radius: ${BORDER_RADIUS.radius19};
      height: 48px;
      @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
        width: 100%;
      }
    `}
`;

export const SelectInput = styled.div<{
  type?: keyof typeof CalendarType;
}>`
  padding: 12px 24px;
  border-radius: ${BORDER_RADIUS.radius21};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  ${({ type }) =>
    type === CalendarType.girdle &&
    css`
      padding: 0;
    `}
`;

export const NavButton = styled.button`
  background: none;
  border: none;
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
`;

export const ImgArrow = styled.img<{ left?: boolean }>`
  width: 16px;
  height: 16px;
  transform: ${({ left }) => (left ? "rotate(90deg)" : "rotate(270deg)")};
`;
